module.exports = __webpack_public_path__ + "duo_banner_background.c08a3322.svg";